import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../design-system.css';
import './Login.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [logoError, setLogoError] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        const success = await login(username, password);
        if (success) {
            navigate('/');
        } else {
            setError('Credenziali non valide');
        }
    };

    return (
        <div className="login-page">
            <div className="login-card ds-card">
                <div className="login-logo">
                    {logoError ? (
                        <span className="login-logo-text">AISA TALENTGPT</span>
                    ) : (
                        <img
                            src="/favicon.ico"
                            alt="AISA TalentGPT"
                            className="login-logo-img"
                            onError={() => setLogoError(true)}
                        />
                    )}
                </div>

                <p className="login-subtitle">Accedi al portale</p>

                {error && <div className="login-error">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="login-field">
                        <label className="login-label">Username</label>
                        <input
                            type="text"
                            className="ds-input"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>
                    <div className="login-field">
                        <label className="login-label">Password</label>
                        <input
                            type="password"
                            className="ds-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="ds-btn ds-btn-primary ds-btn-block login-submit">
                        Accedi
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
